export default __webpack_public_path__ + "static/media/qana-project-4.3a20155e.webp";